import formMainHubConfig from './formMainHubConfig';
import formConfigLanguage from './formConfigLanguage';
import formGroupAppClientRecommendations from './formGroupAppClientRecommendations';
import formGroupAppClientSpaces from './formGroupAppClientSpaces';

export default {
  title: 'White Label Pro Config Form',
  attributeName: 'mhConfigs',
  createURL: 'mainHubs/mainHubId/mainHubConfigs',
  updateURL: 'mainHubs/mainHubId/mainHubConfigs',
  removeURL: 'mainHubs/mainHubId/mainHubConfigs/id/data',
  autoUpdate: false,
  idAttribute: 'id',
  idUpdate: false,
  // noUpdateWithId: false,
  sessionParams: ['mainHubId','mainHubSlugName'],
  formConfig: [formMainHubConfig, formConfigLanguage,formGroupAppClientRecommendations,formGroupAppClientSpaces],
  formGroupExpands: false,
  noArea: true,
  goBackUrl: '/wlpro/mainHubSlugName/configs',
  goBack: true,
};
